module.exports = __webpack_public_path__ + "img/nextArrow.0dcdc198.svg";